import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./VerifyCode.module.css";
import logo from "../../../assets/images/logo.png";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { IoChevronBackOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import { TbLockCheck } from "react-icons/tb";
import { PiSealCheck } from "react-icons/pi";
import { roles } from "../../../config/roles";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import Storage from "../../../utills/AsyncStorage";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { validateForm } from "../../../utills/Validators";
import SubHeadingComponent from "../../../components/SubHeadingComponent/SubHeadingComponent";

function VerifyCode() {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);

  console.log("Location", location?.state);

  const formState = [{ message: "Please Enter Otp", value: otp }];

  // const naviagteScreens = () => {
  //   setIsSuccessFulModal(false)
  //   if (location?.state?.role == roles.user) {
  //     navigate("/moduleRegistration", { state: "userModule" });
  //   } else {
  //     navigate("/accountSetup");
  //   }
  // };

  // const onResendCode = () => {
  //   let userdata = {
  //     role: location.state.role.toLowerCase(),
  //     email: location.state.email,
  //   };

  //   dispatch(AuthMiddleware.forgetPassword(userdata));
  // };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline color="var(--white-color)" />
            <TextComponent
              color="var(--white-color)"
              fontFamily={"Urbanist-light"}
              text={"Back to login"}
              className={styles.White_text}
              cursor={"pointer"}
            />
          </div>
          <div className={styles.textDiv}>
            <SubHeadingComponent
              text={"Verify Code"}
              color={"var(--white-color)"}
            />
            <TextComponent
              className={styles.welcomeText}
              color="var(--white-color)"
              padding={"0px"}
              text={"Please enter your verification code from email address"}
            />
          </div>
          <div
            className={styles.enterCodeDiv}
            //   style={{textDecorationColor}}
          >
            <TextComponent className={styles.White_text} text={"Enter Code"} />
            <div className={styles.resendCodeDiv}>
              <TextComponent
                padding={"0px"}
                text={"Didn't get code?  "}
                className={styles.White_text}
              />
              <TextComponent
                padding={"0px"}
                className={styles.Resend_text}
                // onClick={
                //   location?.state?.screen == "signup" ? null : onResendCode
                // }
                text={" Resend"}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <OTPInput
              containerStyle={styles.otpInputDiv}
              inputStyle={{
                width: "100%",
                height: "65px",
                border: "1px solid var(--orange-color)",
                borderRadius: "50%",
                fontSize: "25px",
              }}
              // inputStyle={styles.otpInput}
              value={otp}
              onChange={setOtp}
              numInputs={5}
              renderSeparator={<span>&emsp;</span>}
              renderInput={(props) => <input type="number" {...props} />}
               isInputNum={true}
              inputType="number"
            />
          </div>
          <div className={styles.btn}>
            <SubmitButton
              btnContainerClass={styles.btnContainer}
              btnClass={`${styles.btnClass}`}
              primary
              title={"Verify"}
              onClick={() => navigate("/createPassword")}
            />
          </div>
        </div>
      </div>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Email Verified successfully"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"Setup  your account"}
        onBtnPress={() => setIsSuccessFulModal(false)}
        // onBtnPress={onPressVerify}
      ></Modal>
    </div>
  );
}

export default VerifyCode;
